import React, { Component } from 'react';
import { td } from 'react-bootstrap';

class SchedulePreference extends Component {
  render() {
    return (
      <div className="card">
        <div className="card-header"> Latest entries</div>
        <div className="card-body">
          <table className="table">
            <thead>
              <tr>
                <th>Day</th>
                <th className="text-right">Available time</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Monday</td>
                <td className="text-right">HH:SS</td>
              </tr>
              <tr>
                <td>Tuesday</td>
                <td className="text-right">HH:SS</td>
              </tr>
              <tr>
                <td>Wednesday</td>
                <td className="text-right">HH:SS</td>
              </tr>
              <tr>
                <td>Thursday</td>
                <td className="text-right">HH:SS</td>
              </tr>
              <tr>
                <td>Friday</td>
                <td className="text-right">HH:SS</td>
              </tr>
              <tr>
                <td>Saturday</td>
                <td className="text-right">HH:SS</td>
              </tr>
              <tr>
                <td>Sunday</td>
                <td className="text-right">HH:SS</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default SchedulePreference;
